export default "__VITE_ASSET__BwvtoRfH__"